import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../navbarv2/navbar';
import Footer from '../navbarv2/footer';
import kk from '../img/KK-zoo.png';
import cm from '../img/CM-zoo.png';
import kn from '../img/KN-zoo.png';
import nm from '../img/NM-zoo.png';
import sk from '../img/SK-zoo.png';
import ub from '../img/UB-zoo.png';
import addpay from '../img/zoptaddpay.png';
import oss from '../img/logo.png';

/* ─── Zoo data ─────────────────────────────── */
const ZOO_PAGES = [
  {
    logo: kk, name: "สวนสัตว์เปิดเขาเขียว", short: "เขาเขียว",
    location: "ชลบุรี", emoji: "🦛", color: "#16a34a",
    url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fkkopenzoo&tabs=timeline&width=500&height=700&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233"
  },
  {
    logo: ub, name: "สวนสัตว์อุบลราชธานี", short: "อุบลฯ",
    location: "อุบลราชธานี", emoji: "🐘", color: "#0891b2",
    url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Feduubonzoo&tabs=timeline&width=500&height=700&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233"
  },
  {
    logo: cm, name: "สวนสัตว์เชียงใหม่", short: "เชียงใหม่",
    location: "เชียงใหม่", emoji: "🐼", color: "#7c3aed",
    url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FFanpageChiangMaiZoo&tabs=timeline&width=500&height=700&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233"
  },
  {
    logo: nm, name: "สวนสัตว์นครราชสีมา", short: "โคราช",
    location: "นครราชสีมา", emoji: "🦒", color: "#d97706",
    url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FNakhonratchasimaZoo&tabs=timeline&width=500&height=700&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233"
  },
  {
    logo: kn, name: "สวนสัตว์ขอนแก่น", short: "ขอนแก่น",
    location: "ขอนแก่น", emoji: "🦁", color: "#dc2626",
    url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FKhonkaenzoo&tabs=timeline&width=500&height=700&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233"
  },
  {
    logo: sk, name: "สวนสัตว์สงขลา", short: "สงขลา",
    location: "สงขลา", emoji: "🐧", color: "#0284c7",
    url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FSongkhlaZooPage&tabs=timeline&width=500&height=700&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233"
  },
];

const MARQUEE_IMGS = [addpay, oss, kk, cm, kn, nm, sk, ub, addpay, oss, kk, cm, kn, nm, sk, ub];

/* ─── Intersection reveal hook ─── */
function useReveal(delay = 0) {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVis(true); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, vis];
}

/* ─── Zoo selector tab ─── */
function ZooTab({ zoo, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "10px 18px",
        borderRadius: 14,
        border: active ? `2px solid ${zoo.color}` : "2px solid transparent",
        background: active ? `${zoo.color}18` : "rgba(255,255,255,.6)",
        backdropFilter: "blur(8px)",
        cursor: "pointer",
        boxShadow: active ? `0 4px 16px ${zoo.color}33` : "0 2px 8px rgba(0,0,0,.06)",
        transform: active ? "translateY(-2px)" : "none",
        transition: "all .22s ease",
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      <span style={{ fontSize: 20 }}>{zoo.emoji}</span>
      <div style={{ textAlign: "left" }}>
        <div style={{
          fontSize: 13, fontWeight: 700,
          color: active ? zoo.color : "#374151",
          fontFamily: "'Prompt', sans-serif",
          lineHeight: 1.2,
        }}>{zoo.short}</div>
        <div style={{ fontSize: 10, color: "#9ca3af" }}>{zoo.location}</div>
      </div>
    </button>
  );
}

/* ─── Facebook iframe card ─── */
function ZooCard({ zoo, index }) {
  const [ref, vis] = useReveal();
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      ref={ref}
      style={{
        opacity: vis ? 1 : 0,
        transform: vis ? "translateY(0)" : "translateY(28px)",
        transition: `opacity .55s ease ${index * 0.08}s, transform .55s ease ${index * 0.08}s`,
      }}
    >
      <div style={{
        background: "#fff",
        borderRadius: 20,
        overflow: "hidden",
        border: `1px solid ${zoo.color}22`,
        boxShadow: `0 4px 24px rgba(0,0,0,.07), 0 0 0 1px ${zoo.color}11`,
        transition: "box-shadow .3s, transform .3s",
      }}
        onMouseEnter={e => {
          e.currentTarget.style.boxShadow = `0 12px 40px ${zoo.color}28, 0 0 0 2px ${zoo.color}33`;
          e.currentTarget.style.transform = "translateY(-4px)";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.boxShadow = `0 4px 24px rgba(0,0,0,.07), 0 0 0 1px ${zoo.color}11`;
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        {/* Card header */}
        <div style={{
          background: `linear-gradient(135deg, ${zoo.color}ee, ${zoo.color}bb)`,
          padding: "14px 18px",
          display: "flex", alignItems: "center", gap: 12,
        }}>
          <div style={{
            width: 44, height: 44, borderRadius: 12,
            background: "rgba(255,255,255,.2)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 22, flexShrink: 0,
          }}>{zoo.emoji}</div>
          <div>
            <div style={{
              fontFamily: "'Prompt', sans-serif",
              fontSize: 15, fontWeight: 700, color: "#fff", lineHeight: 1.2,
            }}>{zoo.name}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,.75)", marginTop: 2 }}>
              📍 {zoo.location}
            </div>
          </div>
          {/* FB icon */}
          <div style={{ marginLeft: "auto", opacity: .6 }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </div>
        </div>

        {/* Iframe area */}
        <div style={{ position: "relative", background: "#f3f4f6" }}>
          {!loaded && (
            <div style={{
              position: "absolute", inset: 0, zIndex: 2,
              display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
              background: "#f9fafb", gap: 12, minHeight: 200,
            }}>
              <div style={{
                width: 36, height: 36, borderRadius: "50%",
                border: `3px solid ${zoo.color}33`,
                borderTopColor: zoo.color,
                animation: "spin .8s linear infinite",
              }}/>
              <div style={{ fontSize: 13, color: "#9ca3af" }}>กำลังโหลด...</div>
            </div>
          )}
          <iframe
            src={zoo.url}
            width="100%"
            height="580"
            style={{
              border: "none", overflow: "hidden", display: "block",
              opacity: loaded ? 1 : 0, transition: "opacity .4s",
            }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen
            title={`Facebook - ${zoo.name}`}
            onLoad={() => setLoaded(true)}
          />
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════
   MAIN COMPONENT
═══════════════════════════════ */
function ZooFacebookPage() {
  const [activeFilter, setActiveFilter] = useState("all");

  const displayed = activeFilter === "all"
    ? ZOO_PAGES
    : ZOO_PAGES.filter(z => z.short === activeFilter);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Prompt:wght@400;600;700;800&family=Sarabun:wght@400;500;600&display=swap');
        *, *::before, *::after { box-sizing: border-box; }
        body { background: #f0f4f0; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes marqueeScroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @keyframes fadeDown {
          from { opacity: 0; transform: translateY(-16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0%   { background-position: -200% center; }
          100% { background-position:  200% center; }
        }
        @keyframes float {
          0%,100% { transform: translateY(0); }
          50%     { transform: translateY(-6px); }
        }
        ::-webkit-scrollbar { height: 4px; width: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }
      `}</style>

      <div style={{ fontFamily: "'Sarabun', sans-serif", background: "#f0f4f0", minHeight: "100vh" }}>
        <Navbar />

        {/* ── MARQUEE ── */}
        <div style={{
          background: "#fff",
          borderBottom: "1px solid #e5e7eb",
          padding: "10px 0",
          overflow: "hidden",
        }}>
          <div style={{
            display: "flex", gap: 32, alignItems: "center",
            width: "max-content",
            animation: "marqueeScroll 28s linear infinite",
          }}>
            {MARQUEE_IMGS.map((src, i) => (
              <img key={i} src={src} alt="" style={{
                height: 36, width: "auto", objectFit: "contain",
                opacity: .7, filter: "grayscale(20%)",
              }}/>
            ))}
          </div>
        </div>

        {/* ── HERO ── */}
        <div style={{
          position: "relative", overflow: "hidden",
          background: "linear-gradient(135deg,#14532d 0%,#166534 50%,#15803d 100%)",
          padding: "56px 24px 72px",
          textAlign: "center",
        }}>
          {/* dots bg */}
          <div style={{
            position: "absolute", inset: 0, pointerEvents: "none",
            backgroundImage: "radial-gradient(rgba(255,255,255,.08) 1.5px, transparent 1.5px)",
            backgroundSize: "24px 24px",
          }}/>
          {/* glow */}
          <div style={{
            position: "absolute", top: "-40%", left: "50%", transform: "translateX(-50%)",
            width: 600, height: 400, borderRadius: "50%",
            background: "radial-gradient(circle, rgba(74,222,128,.12) 0%, transparent 70%)",
            pointerEvents: "none",
          }}/>
          {/* decos */}
          {["🐾","🌿","🦁","🐼"].map((e, i) => (
            <div key={i} style={{
              position: "absolute",
              top: `${15 + (i % 2) * 50}%`,
              left: i < 2 ? `${3 + i * 5}%` : undefined,
              right: i >= 2 ? `${3 + (i-2) * 5}%` : undefined,
              fontSize: "clamp(20px,3vw,36px)",
              opacity: .1, pointerEvents: "none",
              animation: `float ${3 + i * .7}s ease-in-out infinite`,
            }}>{e}</div>
          ))}

          <div style={{ position: "relative", zIndex: 2, animation: "fadeDown .7s ease" }}>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(255,255,255,.1)", backdropFilter: "blur(8px)",
              border: "1px solid rgba(255,255,255,.2)",
              borderRadius: 100, padding: "5px 16px",
              fontSize: 12, color: "rgba(255,255,255,.85)",
              fontWeight: 600, letterSpacing: ".1em",
              marginBottom: 18,
            }}>
              📘 FACEBOOK PAGE
            </div>

            <h1 style={{
              fontFamily: "'Prompt', sans-serif",
              fontSize: "clamp(28px,6vw,54px)",
              fontWeight: 800, color: "#fff",
              lineHeight: 1.1, marginBottom: 14, letterSpacing: "-.02em",
            }}>
              ข่าวสาร{" "}
              <span style={{
                background: "linear-gradient(90deg,#86efac,#d9f99d,#86efac)",
                backgroundSize: "200% auto",
                WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                animation: "shimmer 3s linear infinite",
              }}>
                สวนสัตว์
              </span>
            </h1>
            <p style={{
              fontSize: "clamp(13px,2vw,17px)",
              color: "rgba(255,255,255,.7)",
              maxWidth: 480, margin: "0 auto",
              lineHeight: 1.8,
            }}>
              ติดตามข่าวสาร กิจกรรม และความเคลื่อนไหวล่าสุด<br/>
              จากสวนสัตว์ทั่วประเทศไทย
            </p>

            {/* Stats */}
            <div style={{
              display: "flex", justifyContent: "center", gap: "clamp(20px,5vw,48px)",
              flexWrap: "wrap", marginTop: 32,
            }}>
              {[["6", "สวนสัตว์"], ["24/7", "อัปเดต"], ["100K+", "ผู้ติดตาม"]].map(([val, label]) => (
                <div key={label}>
                  <div style={{
                    fontFamily: "'Prompt', sans-serif",
                    fontSize: "clamp(22px,4vw,32px)", fontWeight: 800, color: "#fff",
                  }}>{val}</div>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,.5)", marginTop: 2 }}>{label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* wave */}
          <div style={{ position: "absolute", bottom: -2, left: 0, right: 0, height: 50, overflow: "hidden" }}>
            <svg viewBox="0 0 1440 50" preserveAspectRatio="none" style={{ width: "100%", height: "100%", display: "block" }}>
              <path d="M0,25 C360,50 1080,0 1440,25 L1440,50 L0,50 Z" fill="#f0f4f0"/>
            </svg>
          </div>
        </div>

        {/* ── FILTER TABS ── */}
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "28px 20px 0" }}>
          <div style={{
            display: "flex", gap: 10, flexWrap: "nowrap",
            overflowX: "auto", paddingBottom: 8,
          }}>
            {/* All button */}
            <button
              onClick={() => setActiveFilter("all")}
              style={{
                display: "flex", alignItems: "center", gap: 8,
                padding: "10px 20px", borderRadius: 14, flexShrink: 0,
                border: activeFilter === "all" ? "2px solid #16a34a" : "2px solid transparent",
                background: activeFilter === "all" ? "#16a34a18" : "rgba(255,255,255,.7)",
                color: activeFilter === "all" ? "#16a34a" : "#374151",
                fontFamily: "'Prompt', sans-serif",
                fontSize: 13, fontWeight: 700,
                cursor: "pointer",
                boxShadow: activeFilter === "all" ? "0 4px 14px #16a34a22" : "0 2px 8px rgba(0,0,0,.06)",
                transform: activeFilter === "all" ? "translateY(-2px)" : "none",
                transition: "all .22s",
              }}
            >
              🗺️ ทั้งหมด
              <span style={{
                background: "#16a34a", color: "#fff",
                fontSize: 10, fontWeight: 800,
                padding: "2px 7px", borderRadius: 100,
              }}>{ZOO_PAGES.length}</span>
            </button>

            {ZOO_PAGES.map(zoo => (
              <ZooTab
                key={zoo.short}
                zoo={zoo}
                active={activeFilter === zoo.short}
                onClick={() => setActiveFilter(activeFilter === zoo.short ? "all" : zoo.short)}
              />
            ))}
          </div>
        </div>

        {/* ── GRID ── */}
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 20px 60px" }}>
          {/* Section label */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            marginBottom: 20, flexWrap: "wrap", gap: 8,
          }}>
            <div style={{
              fontFamily: "'Prompt', sans-serif",
              fontSize: 15, fontWeight: 700, color: "#374151",
            }}>
              แสดง {displayed.length} สวนสัตว์
            </div>
            <div style={{ fontSize: 12, color: "#9ca3af" }}>
              อัปเดตอัตโนมัติจาก Facebook
            </div>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(min(100%,340px),1fr))",
            gap: 20,
          }}>
            {displayed.map((zoo, i) => (
              <ZooCard key={zoo.name} zoo={zoo} index={i} />
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default ZooFacebookPage;